import type { ActiveProducts } from '@labrav/common'
import type { GetIsFlyoutSubscribedParams } from './MarketplaceMultipleApn.types'

export const PRODUCT_SELECTION_PATH = '/product-selection'
export const FLYOUT_ONBOARDING_PATH = '/flyout/onboarding/company-information'

export const getIsFlyoutSubscribed = ({
  partnerInviteEnabled,
  flyoutProduct,
}: GetIsFlyoutSubscribedParams): boolean =>
  !partnerInviteEnabled || !!flyoutProduct

export const getCompleteOnboardingPath = (
  activeProducts: ActiveProducts | undefined
): string =>
  !activeProducts?.includes('flyout')
    ? PRODUCT_SELECTION_PATH
    : FLYOUT_ONBOARDING_PATH
